import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/EmptyState/EmptyState.tsx
import { jsx } from "react/jsx-runtime";
var cls = (...parts) => parts.filter(Boolean).join(" ");
var emptyStateVariants = cva("buyscout-empty-state", {
  variants: {
    variant: {
      panel: "buyscout-empty-state--panel",
      plain: "buyscout-empty-state--plain"
    }
  },
  defaultVariants: {
    variant: "panel"
  }
});
function EmptyState({ ref, variant, className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ref, className: emptyStateVariants({ variant, className }), ...props });
}
EmptyState.displayName = "EmptyState";
function EmptyStateMedia({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("div", { "aria-hidden": true, ref, className: cls("buyscout-empty-state__media", className), ...props });
}
EmptyStateMedia.displayName = "EmptyStateMedia";
function EmptyStateTitle({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("p", { ref, className: cls("buyscout-empty-state__title", className), ...props });
}
EmptyStateTitle.displayName = "EmptyStateTitle";
function EmptyStateDescription({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("p", { ref, className: cls("buyscout-empty-state__description", className), ...props });
}
EmptyStateDescription.displayName = "EmptyStateDescription";
function EmptyStateActions({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx("div", { ref, className: cls("buyscout-empty-state__actions", className), ...props });
}
EmptyStateActions.displayName = "EmptyStateActions";
export {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateMedia,
  EmptyStateTitle
};
//# sourceMappingURL=EmptyState.mjs.map